import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@global': {
      body: {
        overflowX: 'hidden',
      },
    },
    ratingContainer: {
      display: 'flex',
      gap: 24,
      alignItems: 'center',
      [mediaQuery(breakpoints.mobile)]: {
        flexDirection: 'column',
        gap: 0,
        marginBottom: 12,
        alignItems: 'start',
      },
    },
    container: {
      maxWidth: 1360,
      marginInline: 'auto',

      [mediaQuery(1408)]: {
        paddingInline: 24,
      },
    },
    tag: {
      marginTop: 24,
      marginBottom: 12,
      [mediaQuery(breakpoints.mobile)]: {
        marginBottom: 0,
      },
    },
    heading: {
      fontSize: 60,
      fontWeight: 500,
      lineHeight: '72px',
      marginBottom: 16,

      '&>b': {
        fontWeight: 700,
      },

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '32px',
      },
      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 24,
        lineHeight: '32px',
        marginBottom: 8,
      },
    },
    description: {
      color: '#666',
      fontSize: 20,
      lineHeight: '28px',
      marginBottom: 40,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 16,
        lineHeight: '24px',
      },
      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 14,
        lineHeight: '20px',
      },
    },
    rating: {
      marginTop: 12,
      [mediaQuery(breakpoints.tablet)]: {
        gap: 0,
        '& > div': {
          marginRight: 12,
        },
      },
    },
    otherTools: {
      marginTop: 56,
      marginBottom: 44,

      [mediaQuery(breakpoints.laptop)]: {
        paddingInline: 24,
      },
    },
    listClassName: {
      marginInline: 126,
      '& > li': {
        width: 'fit-content',
        minWidth: 256,
      },
      [mediaQuery(breakpoints.tablet)]: {
        '& > li': {
          width: '302px',
          minWidth: 0,
        },
      },
      [mediaQuery(breakpoints.mobile)]: {
        alignItems: 'center',
        marginInline: 0,
        '& > li': {
          width: '256px',
        },
      },
    },
  }),
  {
    name: 'Home',
  },
);

export default useStyles;
